.marker {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 2px;
	margin-bottom: 2px;
	min-width: 16px;
	height: 16px;
	border-radius: 8px;
	overflow: hidden;
}

.marker-drag-preview {
	background-color: var(--ds-background-neutral-bold, var(--adg3-color-N100));
	width: 16px;
	height: 16px;
}

.marker-drag-preview > span {
	color: var(--ds-text-inverse, var(--adg3-color-N0));
}
